import { Component } from '@angular/core';
import { first } from 'rxjs/operators';
import { AlertService } from '@app/_services';
import { CancellationPolicyService } from '../cancellation-policy.service';

@Component({
    selector: 'app-cancellation-policy-view',
    templateUrl: './cancellation-policy-view.component.html',
    styleUrls: ['./cancellation-policy-view.component.css'],
    standalone: false
})
export class CancellationPolicyViewComponent {

    reservationId: number;
    decision: any = null;
    loading = false;
    searched = false;
    showHelp = false;

    constructor(
        private cancellationPolicyService: CancellationPolicyService,
        private alertService: AlertService
    ) { }

    search() {
        if (!this.reservationId) {
            return;
        }
        this.loading = true;
        this.searched = false;
        this.decision = null;

        this.cancellationPolicyService.evaluateForReservation(this.reservationId)
            .pipe(first())
            .subscribe(
                (res: any) => {
                    this.decision = res?.data?.decision;
                    this.searched = true;
                },
                (err: any) => {
                    this.alertService.error(err);
                    this.searched = true;
                },
                () => { this.loading = false; }
            );
    }

    refundBadgeClass(outcome: string): string {
        if (!outcome) { return ''; }
        switch (outcome) {
            case 'FULL_REFUND_MINUS_FEES': return 'badge-success';
            case 'HALF_REFUND':            return 'badge-warning';
            case 'NO_REFUND':              return 'badge-danger';
            default:                       return 'badge-secondary';
        }
    }

    policyBadgeClass(policyName: string): string {
        if (!policyName) { return ''; }
        switch (policyName) {
            case 'GLOBAL_GRACE_PERIOD': return 'badge-info';
            case 'FLEXIBLE':            return 'badge-success';
            case 'STANDARD_STRICT':     return 'badge-warning';
            case 'MANUAL_OVERRIDE':     return 'badge-dark';
            default:                    return 'badge-secondary';
        }
    }
}
